// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let ReactSelect = require("react-select");
let JsxRuntime = require("react/jsx-runtime");

let Types = {};

function combineManyStyles(styles) {
  return Object.assign(...Belt_Array.concatMany([
    [{}],
    styles
  ]));
}

let Styles = {
  combineManyStyles: combineManyStyles
};

let ClassNames = {};

function wrapOption(option) {
  return {
    wrapped: option
  };
}

function unwrapOption(option) {
  return option.wrapped;
}

let Options = {
  wrapOption: wrapOption,
  unwrapOption: unwrapOption
};

let Props = {};

let Single = {};

let Multi = {};

let Plain = {
  Single: Single,
  Multi: Multi
};

let Single$1 = {};

let Multi$1 = {};

let Grouped = {
  Single: Single$1,
  Multi: Multi$1
};

let Select = {
  Plain: Plain,
  Grouped: Grouped
};

let Single$2 = {};

let Multi$2 = {};

let Plain$1 = {
  Single: Single$2,
  Multi: Multi$2
};

let Single$3 = {};

let Multi$3 = {};

let Grouped$1 = {
  Single: Single$3,
  Multi: Multi$3
};

let Async = {
  Plain: Plain$1,
  Grouped: Grouped$1
};

let Single$4 = {};

let Multi$4 = {};

let Plain$2 = {
  Single: Single$4,
  Multi: Multi$4
};

let Single$5 = {};

let Multi$5 = {};

let Grouped$2 = {
  Single: Single$5,
  Multi: Multi$5
};

let AsyncCreatable = {
  Plain: Plain$2,
  Grouped: Grouped$2
};

let make = ReactSelect.components.Input;

let Input = {
  make: make
};

function make$1(props) {
  let newrecord = {...props};
  return JsxRuntime.jsx(make, (newrecord.onPaste = props.selectProps.onPaste, newrecord));
}

let Input$1 = {
  Input: Input,
  make: make$1
};

exports.Types = Types;
exports.Styles = Styles;
exports.ClassNames = ClassNames;
exports.Options = Options;
exports.Props = Props;
exports.Select = Select;
exports.Async = Async;
exports.AsyncCreatable = AsyncCreatable;
exports.Input = Input$1;
/* make Not a pure module */
